var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClubUpperImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.79,314.84c16.47-.65,21.64-16.5,23.26-25.71-6.87-1.9-10.42-5.25-11.47-7.76s-2.11-14.32-1.69-17.05l-23.57-.64s.63,13.9-2.74,19.79c-1.72,3-5.38,4.38-9.47,5C230.67,295.08,237,315.55,254.79,314.84Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.4,425c-4.46-1.61-12.24-5.71-22.9-16.22C212,391.5,201,377,187.5,371s-26.5,7.25-25.75,21.5,11.25,34.25,42.5,45.75a126.81,126.81,0,0,0,36.26,7.49C251.87,441,252.93,431,252.4,425Z",
    style: {
      fill: "#696969",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250,425c4.45-1.61,12.23-5.71,22.9-16.22,17.5-17.25,28.5-31.75,42-37.75s26.5,7.25,25.75,21.5-11.25,34.25-42.5,45.75a126.8,126.8,0,0,1-36.27,7.49C250.53,441,249.48,431,250,425Z",
    style: {
      fill: "#696969",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.23,77.23S340.34,39.75,280.65,56.37s-84.68,68-118.91,103.39c-17.93,18.51-44.41,25.33-65.71,39.58-68.1,45.56-58,148-5.5,186.64,45.46,33.45,102.26,36.95,176.19,12.28s126.82-39.5,172.66-110.17S442.76,128.1,386.23,77.23Z",
    style: {
      fill: "#ff725e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.23,77.23S340.34,39.75,280.65,56.37s-84.68,68-118.91,103.39c-17.93,18.51-44.41,25.33-65.71,39.58-68.1,45.56-58,148-5.5,186.64,45.46,33.45,102.26,36.95,176.19,12.28s126.82-39.5,172.66-110.17S442.76,128.1,386.23,77.23Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Carpet--inject-47"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "395 459 103 459 132.2 417 365.8 417 395 459",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.14,402.58S375.6,357.53,380,347.19,400,354.58,400,354.58s-22.9-60.56-7.39-73.86,20.68,54.66,20.68,54.66,14-39.15,25.11-24.38-17,45.79-17,45.79,19.2.74,14,13.3-19.2,25.85-19.2,25.85Z",
    style: {
      fill: "#ff725e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397,392.24s-17.72-25.11-8.86-30.28,13.29,10.34,13.29,10.34.74-67.94,14.78-62.77,8.86,46.52,8.86,46.52,17.72-11.81,17,5.17S417.69,393,417.69,393",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.26,
    x2: 397.75,
    y1: 393.72,
    y2: 376.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 414,
    x2: 413.26,
    y1: 401.84,
    y2: 359.75,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 414.74,
    x2: 428.77,
    y1: 387.81,
    y2: 369.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.29 389.29 388.15 389.29 392.06 424 423.38 424 427.29 389.29",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.14,402.58S61.6,357.53,66,347.19,86,354.58,86,354.58,63.07,294,78.58,280.72s20.68,54.66,20.68,54.66,14-39.15,25.11-24.38-17,45.79-17,45.79,19.2.74,14,13.3-19.2,25.85-19.2,25.85Z",
    style: {
      fill: "#ff725e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.15,392.8s-18.36-17.25-18.92-25,11.69,1.67,16.69,5-12.79-21.7-12.24-40.06,10.57-11.12,13.91-3.33,5,15,6.68,16.69,4.45-12.8,11.68-8.91c11.56,6.23-7.23,27.26-3.34,31.16s12.8-16.69,17.25-5.56-14.47,31.15-14.47,31.15",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.83,
    x2: 82.92,
    y1: 391.68,
    y2: 349.96,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.6,
    x2: 95.16,
    y1: 370.54,
    y2: 357.75,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "78.47 378.89 94.05 382.78 101.84 377.22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.29 389.29 74.15 389.29 78.06 424 109.38 424 113.29 389.29",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hair--inject-47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.67,294s-14.67,1.33-20-8,4-20.67-6-24.67-22,9.34-42-2-9.34-26-4-37.33,8-16.67-4.67-24-26.67-28.67-18-49.33,30.67-11.34,42-22,1.33-23.34.67-40.67S196.33,55.33,219,58.67,246.33,86,246.33,101.33s24,19.34,35.34,2S302.33,82,319,89.33s2.67,32,10.67,36,14.66-15.33,38.66-4S379,162.66,367,170c-17.46,10.69,3.13,31.42,6.44,44.11,4.85,18.55-10.08,33.39-28.44,32.56-29.33-1.34-36.67-6-42.67,2.66S315,260,312.33,274s-8,19.33-20,19.33-19.33-10.66-32-5.33S231.67,297.33,225.67,294Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M202.5,389.5a72,72,0,0,0-2.25,24.5c1.25,12.75,7.75,19.5,36,23.75s47.75.75,63.5-6.75,12.18-34.41,8.09-40.58S288,383,262.5,385.25,221.25,383.5,212,385,202.5,389.5,202.5,389.5Z",
    style: {
      fill: "#696969",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.5,393.5s-13.5,3.5-23,6-10.5,3.5-2,4.5,24.5,0,24.5,0-22.5,10.5-34.5,13-34-5.5-36.5-7.5,10.5-2,14-3.5,1.5-3.5-11-5.5-10,9.5,1,17.5,17.5,10.5,31.75,8,33.75-8.5,40.25-20.5S292.5,393.5,292.5,393.5Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.13,313.45l-1.66,33.4s-3,7.76,2.4,12.74,12.36,3.51,16-2.95,3.14-21.41,4.06-27.32-6.27-12-12.18-14.21S196.13,313.45,196.13,313.45Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.07,313.45l1.66,33.4s2.95,7.76-2.4,12.74-12.37,3.51-16.06-2.95-3.14-21.41-4.06-27.32,6.28-12,12.18-14.21S313.07,313.45,313.07,313.45Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.32,263.68s.63,13.9-2.74,19.79S224.47,289,217.53,289s-17.27,5.68-20.64,11.37a103.61,103.61,0,0,0-6.52,14.52l23.16,12.42s-2.53,4.85,0,12,6.31,9.9,5.26,13.48-14.74,29.05-16,33.05a37.69,37.69,0,0,0-1.47,5.68s29.26,5.69,54.73,4.85,51.79-5.9,51.79-5.9-7.79-13.68-12-21.47-8-15.79-7.16-18.53,5.69-10.1,5.48-22.95c0,0,18.73-4.84,25.68-12.63,0,0-8.21-20.42-16.63-23.79s-18.1,0-25-1.89-10.53-5.27-11.58-7.79-2.11-14.32-1.69-17.05Z",
    style: {
      fill: "#ff725e",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,345s-7-7.5,1-8.5,19.5,7,32,10,27.5-10.5,34-8.5,2.5,12-4.5,16.5-26.5,4-37.5,3.5S228.5,354.5,220,345Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,349.64s3.81,3.05,14,3.05,18-4.57,25.14-3.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.68,350.4s4.31,3.56,13.2,3.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.53,327.26s.73-3.77,5.56-7.33",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.16,327.47s-1.69-7.28-6.26-8.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.79,314.84c16.47-.65,21.64-16.5,23.26-25.71-6.87-1.9-10.42-5.25-11.47-7.76s-2.11-14.32-1.69-17.05l-23.57-.64s.63,13.9-2.74,19.79c-1.72,3-5.38,4.38-9.47,5C230.67,295.08,237,315.55,254.79,314.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-47)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.3,274.06a56,56,0,0,1-.41-9.74l-23.57-.64a77.89,77.89,0,0,1-.37,10.73C245.09,277.12,253.48,280.36,265.3,274.06Z",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M254.79,314.84c16.47-.65,21.64-16.5,23.26-25.71-6.87-1.9-10.42-5.25-11.47-7.76s-2.11-14.32-1.69-17.05l-23.57-.64s.63,13.9-2.74,19.79c-1.72,3-5.38,4.38-9.47,5C230.67,295.08,237,315.55,254.79,314.84Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.32,235s-3-4.89-5.95-1.91,0,8.92,1.91,11.68,5.52,4.88,6.37,3.82S231.32,235,231.32,235Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.4,234.56s4.25-5.52,6.59-.21-4,13.38-7,14.87-1.49-3.4-1.28-5.1S277.4,234.56,277.4,234.56Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,216.3s1.49,20.18,2.55,30.37S236.41,266,248.09,269s21-1.06,24.43-7.86,5.31-19.75,5.31-30.37v-17S247.67,205.26,229,216.3Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.49,245.18a7.89,7.89,0,0,0,3.61,1.28,9.24,9.24,0,0,0,3.82-1.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.73,251.77s5.31,3.4,13-.43",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.24,234.56s4.46-.63,7,1.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.05,235.41s4.25-2.12,8.28-.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.26,232.63a33.77,33.77,0,0,0,3.39-7.83,23.6,23.6,0,0,0,1.17-11.22A35.25,35.25,0,0,0,229,216.3S229.56,224.21,230.26,232.63Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.82,230.94c0-.07,0-.13,0-.2v-17s-2.08-.58-5.47-1.24C272.57,215.8,273.56,225.75,277.82,230.94Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.54,227.13s3.61-4.88,11.25-3.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.62,224.37A10.39,10.39,0,0,1,271,226.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.75,426s-9.75,0-27.25-17.25S201,377,187.5,371s-26.5,7.25-25.75,21.5,11.25,34.25,42.5,45.75S262.25,445,265,445s16.25,6.75,24.25,7.5a62.24,62.24,0,0,0,13.25,0s2.25.25,3.5.25,2.75-1.5,2.75-1.5,2.53.66,3.53-1.09.22-2.41.22-2.41,4.28.37,5.78-2.38-.64-2.64-.64-2.64,2.93-.57,2.86-2.93a5.13,5.13,0,0,0-.5-2.55s1.75-2.75,1-5-3.5-3-6.25-1.75-16,.75-26.75,0S256.75,426,256.75,426Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.4,425c-4.46-1.61-12.24-5.71-22.9-16.22C212,391.5,201,377,187.5,371s-26.5,7.25-25.75,21.5,11.25,34.25,42.5,45.75a126.81,126.81,0,0,0,36.26,7.49C251.87,441,252.93,431,252.4,425Z",
    style: {
      fill: "#696969"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-47)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.15,440.34c-4.93-1.87-10.69-3.87-17.15-5.84-23-7-40-15.5-51.5-28.5s-7.5-29.5-7.5-29.5l-2.65-2.4a23.35,23.35,0,0,0-7.6,18.4c.75,14.25,11.25,34.25,42.5,45.75a126.81,126.81,0,0,0,36.26,7.49A19.9,19.9,0,0,0,248.15,440.34Z",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M252.4,425c-4.46-1.61-12.24-5.71-22.9-16.22C212,391.5,201,377,187.5,371s-26.5,7.25-25.75,21.5,11.25,34.25,42.5,45.75a126.81,126.81,0,0,0,36.26,7.49C251.87,441,252.93,431,252.4,425Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,437.25a5.62,5.62,0,0,0-4.86.12",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.64,442.73a5.87,5.87,0,0,0-4,0",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.5,447.75a4.79,4.79,0,0,0-3.22-.95",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.49,451s-1.07-1.93-2.64-1.93",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.66,426s9.75,0,27.25-17.25,28.5-31.75,42-37.75,26.5,7.25,25.75,21.5-11.25,34.25-42.5,45.75-58,6.75-60.75,6.75-16.25,6.75-24.25,7.5a62.24,62.24,0,0,1-13.25,0s-2.25.25-3.5.25-2.75-1.5-2.75-1.5-2.53.66-3.53-1.09-.22-2.41-.22-2.41-4.29.37-5.79-2.38.64-2.64.64-2.64-2.93-.57-2.86-2.93a5,5,0,0,1,.51-2.55s-1.75-2.75-1-5,3.5-3,6.25-1.75,16,.75,26.75,0S245.66,426,245.66,426Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,425c4.45-1.61,12.23-5.71,22.9-16.22,17.5-17.25,28.5-31.75,42-37.75s26.5,7.25,25.75,21.5-11.25,34.25-42.5,45.75a126.8,126.8,0,0,1-36.27,7.49C250.53,441,249.48,431,250,425Z",
    style: {
      fill: "#696969"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-47)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.66,392.5c.52-9.93-5.64-19.36-14-22.15L323,373s12.5,7.5,9.5,22-27.5,29.5-47,37.5a222.3,222.3,0,0,1-29.82,9.33,20.85,20.85,0,0,0,6.21,3.91,126.8,126.8,0,0,0,36.27-7.49C329.41,426.75,339.91,406.75,340.66,392.5Z",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M250,425c4.45-1.61,12.23-5.71,22.9-16.22,17.5-17.25,28.5-31.75,42-37.75s26.5,7.25,25.75,21.5-11.25,34.25-42.5,45.75a126.8,126.8,0,0,1-36.27,7.49C250.53,441,249.48,431,250,425Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.41,437.25a5.62,5.62,0,0,1,4.86.12",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.76,442.73a5.87,5.87,0,0,1,4,0",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.91,447.75a4.79,4.79,0,0,1,3.22-.95",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.92,451S195,449,196.56,449",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.37,349.07s-3.69-.74-10.33,2.58-12.74,9.23-16.25,11.26-5.9,3.33-9,.19-9.78-11.82-16.06-11.63-8.49,8.86-7.38,10.7,2.77,2.22,4.06.74,2.95-4.43,4.61-3.32.74,6.28-1.84,7.2-9.6,5.35-7.94,7.94,11.08,6.09,18.09,6.64,15.69-4.24,21.41-5.17,21.23-2,28.42-7.93a15.1,15.1,0,0,0,5.36-14.22",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.12,370.85s-.73-8.12-3.13-8.68-2.77,5-2.4,10.34,3.32,6.83,5.16,5.35S141.12,370.85,141.12,370.85Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.89,373.14s.7-8.13-1.56-9.1-3.6,4.42-4.19,9.75,2.07,7.31,4.15,6.19S146.89,373.14,146.89,373.14Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.87,375s.71-8.12-1.56-9.09-3.6,4.42-4.18,9.75,2.06,7.31,4.14,6.18S151.87,375,151.87,375Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.93,381a24.22,24.22,0,0,1-10.7,2.22,39.48,39.48,0,0,1-.37-4.62c0-2,4.24-10.33,10.52-9.78",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.16,378.17s2.35-6.36.41-7.84-4.33,2.46-6,6.6.44,6.56,2.64,6.29S157.16,378.17,157.16,378.17Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.82,349.07s3.69-.74,10.34,2.58,12.73,9.23,16.24,11.26,5.91,3.33,9.05.19,9.78-11.82,16.05-11.63,8.49,8.86,7.39,10.7-2.77,2.22-4.06.74-3-4.43-4.62-3.32-.74,6.28,1.85,7.2,9.6,5.35,7.93,7.94-11.07,6.09-18.08,6.64-15.69-4.24-21.42-5.17-21.22-2-28.42-7.93a15.08,15.08,0,0,1-5.35-14.22",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.07,370.85s.74-8.12,3.14-8.68,2.77,5,2.4,10.34-3.32,6.83-5.17,5.35S368.07,370.85,368.07,370.85Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.31,373.14s-.71-8.13,1.55-9.1,3.61,4.42,4.19,9.75S366,381.1,363.91,380,362.31,373.14,362.31,373.14Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.32,375s-.7-8.12,1.56-9.09,3.61,4.42,4.19,9.75-2.07,7.31-4.14,6.18S357.32,375,357.32,375Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.26,381A24.25,24.25,0,0,0,355,383.22a39.48,39.48,0,0,0,.37-4.62c0-2-4.25-10.33-10.53-9.78",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,378.17s-2.35-6.36-.41-7.84,4.32,2.46,6,6.6-.44,6.56-2.64,6.29S352,378.17,352,378.17Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphics--inject-47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273,204c-2.35-3.41-6-.09-6.94.93-1-1-4.59-4.34-6.93-.93-2.55,3.71,6.85,11.44,6.93,11.4S275.52,207.71,273,204Z",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.65,207.06a27.17,27.17,0,0,0-11.44-8.91c-7.32-2.86-2.55-8.58.63-7a44.76,44.76,0,0,0,6.36,2.54s-8.27-6.68-8.58-12.4,8.58,1.59,8.58,1.59S234.39,168,237.89,165.4s6.67,2.23,8.9,6.36a79.52,79.52,0,0,1,4.13,9.54s-.63-10.49,2.87-7.31,1.27,19.08,1.27,19.08,4.77-13,7-6S250.61,206.1,249.65,207.06Z",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.65,207.06s5.09-15.27-5.4-35",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.2,105.69a20.1,20.1,0,0,0-10.37,2.79c-5,3-6.2-2.33-3.84-3.5a34.27,34.27,0,0,0,4.34-2.62s-7.64,1.9-11.16-.47,4.77-4.36,4.77-4.36-13.65-.28-13.59-3.48,4.29-3,7.73-2.42a60.09,60.09,0,0,1,7.48,1.81s-6.48-4.31-3.05-5,11.84,7.76,11.84,7.76-5.57-8.63-.45-6.83S232.06,104.7,232.2,105.69Z",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.2,105.69s-6.74-9.82-23.07-12.42",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.36,168.87a3.86,3.86,0,0,0-.84.11,3.65,3.65,0,1,0-6.14-3.1,3.65,3.65,0,1,0-5.62,4.38,3.65,3.65,0,1,0,4.2,5.86,3.64,3.64,0,0,0,7.26-.13,3.9,3.9,0,0,0,1.14.2,3.66,3.66,0,0,0,0-7.32Z",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.13,
    cy: 171.75,
    r: 2.53,
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.18,197.66a3.88,3.88,0,0,0-.85.11,3.65,3.65,0,1,0-6.13-3.1,3.65,3.65,0,0,0-6.94,1.59,3.62,3.62,0,0,0,1.32,2.79,3.65,3.65,0,1,0,4.2,5.86,3.64,3.64,0,0,0,7.25-.13,3.6,3.6,0,0,0,1.15.2,3.66,3.66,0,0,0,0-7.32Z",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.94,
    cy: 200.54,
    r: 2.53,
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.18,152.18a2.33,2.33,0,0,0-.53.07,2.23,2.23,0,0,0,.71-1.64,2.27,2.27,0,0,0-4.53-.29,2.27,2.27,0,1,0-3.49,2.73,2.24,2.24,0,0,0-1.26,2A2.28,2.28,0,0,0,215,156.7a2.27,2.27,0,0,0,4.52-.09,2.08,2.08,0,0,0,.71.13,2.28,2.28,0,0,0,0-4.56Z",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.3,
    cy: 153.97,
    r: 1.58,
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.57,222a2.25,2.25,0,0,0-.52.07,2.26,2.26,0,0,0,.7-1.64,2.27,2.27,0,0,0-4.52-.29,2.27,2.27,0,1,0-3.5,2.73,2.27,2.27,0,1,0,2.61,3.65,2.27,2.27,0,0,0,4.52-.09,2.13,2.13,0,0,0,.71.13,2.28,2.28,0,0,0,0-4.56Z",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 195.69,
    cy: 223.79,
    r: 1.58,
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.83,114.29a2.25,2.25,0,0,0-.52.07,2.27,2.27,0,1,0-3.82-1.94,2.27,2.27,0,0,0-4.32,1,2.23,2.23,0,0,0,.82,1.73,2.27,2.27,0,0,0,1,4.31,2.24,2.24,0,0,0,1.59-.66,2.27,2.27,0,0,0,4.52-.08,2.41,2.41,0,0,0,.71.13,2.28,2.28,0,1,0,0-4.56Z",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.95,
    cy: 116.08,
    r: 1.58,
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.68,128.68a2.33,2.33,0,0,0-.53.07,2.23,2.23,0,0,0,.71-1.64,2.27,2.27,0,0,0-4.53-.29,2.27,2.27,0,1,0-3.49,2.73,2.24,2.24,0,0,0-1.26,2,2.28,2.28,0,0,0,3.87,1.63,2.27,2.27,0,0,0,4.52-.09,2.08,2.08,0,0,0,.71.13,2.28,2.28,0,0,0,0-4.56Z",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.8,
    cy: 130.47,
    r: 1.58,
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,158a65.54,65.54,0,0,1,4.67-10c2.33-3.67,10.66-4.33,10.66-4.33S274,150.67,272,154,263,158,263,158Z",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,158s6.33-9,13.67-13.33",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.87,190.44a66,66,0,0,1,10.93-1.53c4.34,0,9.45,6.58,9.45,6.58s-8.24.18-12.12.32S166.87,190.44,166.87,190.44Z",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.87,190.44s11,.41,18.63,4.19",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.23,182.83s-1.62-7.53-5.15-7.09-.68,9.3-.68,9.3-4.64,1.32-4.42,3.31,3.52.33,6.38-.11c0,0-1.15,5.17,1.94,6s2.5-6.82,2.5-6.82,6.9,1.41,8.84-1.68C326.89,182.19,318.1,182.38,315.23,182.83Z",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.23,180.51s-6.44,9.79-6.06,10.82,7.35-8.5,8.51-9.66S316.78,178.83,315.23,180.51Z",
    style: {
      fill: "#263238",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.68,181.67s4.25-3.87,6.31-2.32-.38,1.8-.64,1.29",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.62,179.73s1.16-5.67-.13-6.83-1.81.39-.9,1.29",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,135.56c-3.44-5-8.76-.13-10.19,1.36-1.44-1.49-6.76-6.38-10.2-1.36-3.75,5.45,10.07,16.81,10.2,16.76S257.73,141,254,135.56Z",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.27,116.06c-3.56-2.12-5.45,2.41-5.92,3.73-1.31-.51-6-2-6.69,2.06-.76,4.43,11,7.53,11.07,7.46S210.13,118.36,206.27,116.06Z",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.08,157.3c-4.13-.31-3.81,4.59-3.63,6-1.4.13-6.26.86-5.07,4.82,1.29,4.31,13.21,1.83,13.23,1.74S177.56,157.64,173.08,157.3Z",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.17,222.08c3.28-2.53-.23-6-1.29-6.88,1-1,4.09-4.82.56-7-3.84-2.35-11.06,7.45-11,7.53S300.61,224.82,304.17,222.08Z",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.05,154.78a34.81,34.81,0,0,1,7.45-5.28",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.5,195s2.34-19.91,13.3-34.41",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.94,203.45A42.79,42.79,0,0,1,239.5,208",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.71,179.82a16.81,16.81,0,0,0,4.79,2.68c7.91,3,18.95,6,27.54,14.82",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,170.5a9.18,9.18,0,0,0,1,6.13",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.41,118.56a27.3,27.3,0,0,0,6.09-8.06",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.78,147.78a41.61,41.61,0,0,1,6.72-11.28c5.69-6.77,11.82-10,17.27-13.65",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.5,164a37.93,37.93,0,0,1,.65-7",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.68,204.58c4.16-2.1,10-3.68,17.82-3.08,19.5,1.5,28.5,7.5,37-4",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,212a17.38,17.38,0,0,1,3.24-3.72",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.46,159.35h-2.67c-1.61,0-4.55-1.87-3.21-3.48s5.88,2.14,5.88,2.14l-4-12.57,8.56-4,3.48,11.77s-5.35-2.14-5.89.26,3.48,2.14,5.89,1.07",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 316.25,
    x2: 324.54,
    y1: 148.11,
    y2: 144.1,
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.85,155.35h-1.76c-1.07,0-3-1.24-2.13-2.3s3.89,1.41,3.89,1.41l-2.65-8.31,5.66-2.65,2.3,7.78s-3.54-1.41-3.89.18,2.3,1.41,3.89.7",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 335.73,
    x2: 341.21,
    y1: 147.92,
    y2: 145.27,
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.35,146.35h-1.76c-1.07,0-3-1.24-2.13-2.3s3.89,1.41,3.89,1.41l-2.65-8.31,5.66-2.65,2.3,7.78s-3.54-1.41-3.89.18,2.3,1.41,3.89.7",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180.23,
    x2: 185.71,
    y1: 138.92,
    y2: 136.27,
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,174.46s7.24-2.18,6.09-6.46c-1-3.62-4.38,0-4.38,0s2.1-3.4-1-5-4,2.78-4,2.78-.62-4.06-3.44-2.19,3.13,11.89,3.13,11.89Z",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.72,189.91a38.49,38.49,0,0,0,5.63-14.4l3.08-9.52",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.47,182.4a8,8,0,0,0-1.25-5.64,22.27,22.27,0,0,0-4.06-5s-.94,3.44-.32,5.63S344.47,182.4,344.47,182.4Z",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.54,184.9a6.47,6.47,0,0,1,4.38-1.56h5.94S346.35,189.28,343.54,184.9Z",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "345.39 167.6 346.33 175 351.58 171.1",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.47,206.73s-4.74-5.88-8.27-3.21c-3,2.27,1.65,4.06,1.65,4.06s-3.95-.66-4.22,2.83S174.7,213,174.7,213s-3.53,2.11-.73,4,9.84-7.38,9.84-7.38Z",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.26,209.48a38.38,38.38,0,0,0-15.45.2l-10,.74",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.89,208.83a8,8,0,0,0-4.75,3.28,22.25,22.25,0,0,0-3.1,5.65s3.54-.42,5.33-1.83S190.89,208.83,190.89,208.83Z",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.56,208.76a6.47,6.47,0,0,1-3.1-3.47c-1.05-2.61-2.23-5.51-2.23-5.51S196.56,204.5,193.56,208.76Z",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "176.84 213.55 183.34 209.89 177.75 206.5",
    style: {
      fill: "none",
      stroke: "#ff725e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.84,181.59a21.9,21.9,0,0,0-1-2c-1.79-3.29-4.42-6.18-8.55-5.59-7,1,6,12,8.34,12.33C231.51,186.74,230.77,183.81,229.84,181.59Z",
    style: {
      fill: "#ff725e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.51,140.26c-.36-.85-.74-1.59-1-2-1.8-3.3-4.42-6.18-8.55-5.59-7,1,6,12,8.34,12.33C226.18,145.41,225.44,142.47,224.51,140.26Z",
    style: {
      fill: "#ff725e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.87,185.65c-.89.26-1.67.56-2.1.73-3.48,1.4-6.65,3.68-6.54,7.85.19,7.07,12.61-4.58,13.21-6.87C300.17,184.59,297.17,185,294.87,185.65Z",
    style: {
      fill: "#ff725e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.87,148.32a21.32,21.32,0,0,0-2.1.73c-3.48,1.4-6.65,3.67-6.54,7.84.19,7.07,12.61-4.58,13.21-6.86C309.17,147.25,306.17,147.65,303.87,148.32Z",
    style: {
      fill: "#ff725e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.12,146a19.41,19.41,0,0,0-2.09.73c-3.48,1.4-6.65,3.67-6.54,7.84.19,7.07,12.61-4.58,13.21-6.86C360.43,144.9,357.43,145.3,355.12,146Z",
    style: {
      fill: "#ff725e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.59,180a10.5,10.5,0,0,0-.47-1c-.87-1.6-2.15-3-4.17-2.73-3.42.49,2.93,5.86,4.07,6C215.41,182.51,215.05,181.08,214.59,180Z",
    style: {
      fill: "#ff725e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.18,154.06c-.34-.29-.68-.53-.86-.66-1.51-1.05-3.28-1.73-4.95-.57-2.84,2,5.24,3.92,6.33,3.56C192,155.94,191.07,154.83,190.18,154.06Z",
    style: {
      fill: "#ff725e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.26,166.33a10.08,10.08,0,0,0-.47-1c-.88-1.61-2.16-3-4.17-2.73-3.42.49,2.93,5.85,4.07,6C227.07,168.85,226.71,167.41,226.26,166.33Z",
    style: {
      fill: "#ff725e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.39,143.81a9.37,9.37,0,0,0-.47-1c-.87-1.61-2.15-3-4.17-2.73-3.42.49,2.93,5.86,4.07,6C168.21,146.32,167.85,144.89,167.39,143.81Z",
    style: {
      fill: "#ff725e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.3,178.84a9.79,9.79,0,0,0-1-.53c-1.64-.8-3.5-1.2-5,.2-2.5,2.39,5.79,3.07,6.81,2.54C185.43,180.41,184.3,179.45,183.3,178.84Z",
    style: {
      fill: "#ff725e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.26,127a10.5,10.5,0,0,0-.47-1c-.88-1.6-2.16-3-4.17-2.73-3.42.49,2.93,5.86,4.07,6C224.07,129.51,223.71,128.08,223.26,127Z",
    style: {
      fill: "#ff725e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.87,167.64c-.27.35-.5.69-.62.88-1,1.54-1.61,3.35-.38,5,2.08,2.76,3.72-5.39,3.31-6.47C262.68,165.71,261.6,166.72,260.87,167.64Z",
    style: {
      fill: "#ff725e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.87,188.64c-.27.35-.5.69-.62.88-1,1.54-1.61,3.35-.38,5,2.08,2.76,3.72-5.39,3.31-6.47C278.68,186.71,277.6,187.72,276.87,188.64Z",
    style: {
      fill: "#ff725e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.15,134a9.89,9.89,0,0,0-1,.33c-1.71.65-3.28,1.73-3.27,3.76,0,3.45,6.2-2.1,6.52-3.21C301.75,133.48,300.29,133.64,299.15,134Z",
    style: {
      fill: "#ff725e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.53,121.43c-.32.31-.6.61-.75.78-1.21,1.37-2.1,3.06-1.13,4.85,1.63,3,4.49-4.76,4.26-5.88C262.62,119.8,261.39,120.63,260.53,121.43Z",
    style: {
      fill: "#ff725e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.58,192a9.56,9.56,0,0,0,.82.7c1.45,1.13,3.19,1.9,4.92.83,2.93-1.81-5-4.19-6.14-3.88C189.83,190,190.73,191.17,191.58,192Z",
    style: {
      fill: "#ff725e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.52,134.37c-.44,0-.85,0-1.08,0-1.83.11-3.65.67-4.25,2.61-1,3.3,6.55-.15,7.18-1.11C319.14,134.7,317.7,134.42,316.52,134.37Z",
    style: {
      fill: "#ff725e"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClubUpperImage);
export default __webpack_public_path__ + "static/media/ClubUpperImage.9e81d0fa4618a8b0d7a653bfa412ee28.svg";
export { ForwardRef as ReactComponent };